<template>
<div class="modal fade" tabindex="-1" :class="{'mostrar' : modalz}" role="dialog" aria-labelledby="myModalLabel"  aria-hidden="true">
    <div class="modal-dialog modal-primary modal-lg" role="document" >
        <div class="modal-content" :style="'top:'+scroll+'px'">
            <div class="modal-header">
                <h4 class="modal-title" ></h4>
                <button type="button" class="close" @click="cerrarModal()" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="product-details"><!--product-details-->
                    <div class="row detallesPro">
                            <div class="col-sm-12" >
                               
                                <div v-if="imagenes.length>1" class="view-product">
                                    <figure v-for="(img,index) in imagenes" :key="index" >
                                        <img  :class="`img${img.orden} ${[img.orden == 1 ? '' : 'display']}`" width="100%" :src="`${dominio}/img/productos/${img.nombre}`" alt="" />
                                    </figure>
                                </div>
                                <div v-else class="view-product">
                                    <figure v-for="(img,index) in imagenes" :key="index" >
                                        <img width="100%" :src="`${dominio}/img/productos/${img.nombre}`" alt="" />
                                    </figure>
                                </div>
                                <div id="similar-product" class="carousel slide" data-ride="carousel">
                                    
                                   
                                    <a class="left item-control" href="#similar-product" data-slide="prev">
                                        <i class="fa fa-angle-left"></i>
                                    </a>
                                    <a class="right item-control" href="#similar-product" data-slide="next">
                                        <i class="fa fa-angle-right"></i>
                                    </a>
                                </div>

                            </div>
                          
                           
                        </div><!--/product-details-->
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="cerrarModal()">Cancelar</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
     
</div>
<!--Fin del modal-->
</template>
<script>
import { mapState} from 'vuex'
 export default {
    props:{
        modalz:0,
        imagenes:[],
        scroll:0
    },
    data(){
        return{
           
            
        }
    },
    computed:{
       ...mapState(['dominio']),
        
      
      
    },
    methods: {
      
         cerrarModal(){
            this.$emit('cerrarModalz', 0)
        }
       
    },
    mounted() {
       
        //    ,area:producto.tipo.area,sobrante:producto.tipo.sobrante,impresiones:producto.tipo.impresiones,cabida:producto.tipo.cabida,valor:producto.tipo.valor
    },
    created() {
       
        //this.validarCantidad()
    },
}

</script>

<style> 
    .imagenproducto:hover{
        transform: scale(2);
    }
    .product-details{
        margin-bottom: 0;
    }
   
    .atributos{
        margin:5px 0;
        border-bottom: solid 1px #000000;
        padding-bottom: 5px;
    }   
    .atributos h4{
        display: flex;
        justify-content: space-between;
        margin-bottom: 2px;
    }
    .atributos h4 label{
        font-size: 16px;
    }
    .atributos h4 input{
        width:60%;
        font-size: 12px;
    }
    .atributos select{
        font-size: 12px;
    }
    .totales h4{
        display: flex;
        flex-direction: row;
        font-size: 16px;
        margin-top:8px;
    }
    .ul-atributos{
        list-style: none;
    }
    .detallesPro{
        padding:0px 10px;
        background: rgb(245, 245, 245);
    }
    .modal-content{
        width: 100% !important;
        position: absolute !important;
    }
    .modal-body{
        padding:0 !important;
    }
    .mostrar{
        display: list-item !important;
        opacity: 1 !important;
        position: absolute !important;
        background-color: #3c29297a !important;
    }
    .div-error{
        display: flex;
        justify-content: center;
    }
    .text-error{
        color: red !important;
        font-weight: bold;
    }
    .view-product{
        cursor:pointer;
    }
    .display{
        display:none;
    }
    .view-product:hover .img1{
        display:none
    }
    .view-product:hover .img2{
        display:block
    }
    .product-information{
        padding-bottom:0px; 
        padding-left: 0px;
        padding-top: 0px;
    }
    .product-information span{
        display:flex;
        flex-direction: column;
    }
</style>
